import React from 'react';
import { Outlet } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaSteam } from 'react-icons/fa';
import CsgoNav from '../../components/CsgoNav';

function Csgo() {
  return (
    <div className="csgo-layout animate-fade-in">
      <div className="sticky-bar p-3 mb-4 rounded-3 shadow-sm bg-white">
        <div className="d-flex align-items-center">
          <div className="bg-primary-subtle p-2 rounded-2 me-3">
            <FaSteam className="text-accent" size={20} />
          </div>
          <h1 className="h5 mb-0 fw-bold">Espace Investissement CS:GO</h1>
        </div>
      </div>

      <Row className="g-4">
        <Col md={3} xl={2}>
          <div className="sticky-top" style={{ top: '130px' }}>
            <div className="card shadow-sm border-0">
              <div className="card-body p-2">
                <CsgoNav />
              </div>
            </div>
          </div>
        </Col>
        <Col md={9} xl={10}>
          <div className="ps-md-2">
            <Outlet />
          </div>
        </Col>
      </Row>
    </div>
  );
}
export default Csgo;
